import React, { createContext, useContext, useCallback, useState } from 'react';

interface ActivitiesSidebarContextType {
  isOpen: boolean;
  openSidebar: () => void;
  closeSidebar: () => void;
  toggleSidebar: () => void;
}

const ActivitiesSidebarContext = createContext<ActivitiesSidebarContextType | undefined>(undefined);

export const ActivitiesSidebarProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openSidebar = useCallback(() => setIsOpen(true), []);
  const closeSidebar = useCallback(() => setIsOpen(false), []);
  const toggleSidebar = useCallback(() => setIsOpen((prev) => !prev), []);

  return (
    <ActivitiesSidebarContext.Provider
      value={{
        isOpen,
        openSidebar,
        closeSidebar,
        toggleSidebar,
      }}
    >
      {children}
    </ActivitiesSidebarContext.Provider>
  );
};

export const useActivitiesSidebar = (): ActivitiesSidebarContextType => {
  const context = useContext(ActivitiesSidebarContext);
  if (!context) {
    throw new Error('useActivitiesSidebar must be used within ActivitiesSidebarProvider');
  }
  return context;
};
